import { useEffect, useState } from 'react';
import { BadgeCheck, ShieldQuestion } from 'lucide-react';
import api from '../lib/api';

const LABEL = {
  verified: 'ID verified', pending_review: 'ID under review',
  rejected: 'ID rejected', photo_requested: 'Better ID photo needed',
  unverified: 'ID not verified',
};

/** Verified badge for the counter and the request / prescription screens. */
export const IdentityBadge = ({ patientId, compact = false }) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!patientId) return;
    let live = true;
    api.get(`/staff/identity/badge/${patientId}`)
      .then(r => { if (live) setState(r.data); })
      .catch(() => { if (live) setState(null); });
    return () => { live = false; };
  }, [patientId]);
  if (!state) return null;
  const verified = state.verified;
  return (
    <span className={`care-kyc-badge care-kyc-${verified ? 'verified' : state.status === 'rejected' ? 'rejected' : 'pending_review'}`}
      title={state.id_type_label || ''} data-testid={`identity-badge-${patientId}`}>
      {verified ? <BadgeCheck size={13} className="inline mr-1" /> : <ShieldQuestion size={13} className="inline mr-1" />}
      {compact ? (verified ? 'Verified' : 'Unverified') : (LABEL[state.status] || state.status)}
    </span>
  );
};
